import React from 'react'
import { Interpolation } from 'styled-components'

import {
  GetSiteFixturesQuery,
  NavAccordionSectionFragment,
  NavListGroupSectionFragmentFragment,
  NavListSectionFragmentFragment,
  NavListSectionItemFragmentFragment,
  NavTileSectionFragment,
  RawHtmlSectionFragmentFragment,
} from '../../__generated__/graphql/catalog/graphql'

export enum AlternateModelVariantAction {
  replaceOriginal = 'Replace Original',
  hideOriginal = 'Hide Original',
}

type ClickishEvent = React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>

type ClientSideNavListItemAdditions = {
  asTag?: keyof JSX.IntrinsicElements
  role?: string
  textRole?: string
  isInFooter?: boolean
  hasDivider?: boolean
  onClickish?: (event: ClickishEvent) => void
  trackingLabel?: string
}

type ClientSideNavSectionAdditions = {
  styles?: Interpolation<object>
}

type ClientSideNavTabAdditions = {
  ariaLabel?: string
  onClickish?: (event: ClickishEvent) => void
  render?: () => React.ReactNode
  wrapperElement?: 'div' | 'button' | 'a'
}

type NavListItemData = NavListSectionItemFragmentFragment

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavListItem = NavListItemData & ClientSideNavListItemAdditions

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavListSectionData = NavListSectionFragmentFragment

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavListSectionVariant = NavListSectionData['variant']

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavListSection = Omit<NavListSectionData, 'items'> & {
  items: Array<NavListSectionData['items'][number] & ClientSideNavListItemAdditions>
} & ClientSideNavSectionAdditions

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavListGroupSectionData = NavListGroupSectionFragmentFragment

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavListGroupSection = NavListGroupSectionData & ClientSideNavSectionAdditions

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavTileSectionData = NavTileSectionFragment

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavTileSection = NavTileSectionData & ClientSideNavSectionAdditions

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavTileData = NavTileSectionData['tiles'][number]

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavTile = NavTileData & {}

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavAccordionData = NavAccordionSectionFragment

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavAccordion = NavAccordionData & {
  startOpenSet?: number[]
}

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavAccordionVariant = NavAccordionData['variant']

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavAccordionSection = NonNullable<NavAccordionData['sections'][number]>

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavSectionData =
  | NavListSectionData
  | NavListGroupSectionData
  | NavTileSectionData
  | NavAccordionData
  | RawHtmlSectionFragmentFragment
  | NavRegionLocaleSection

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavSection =
  | NavListSection
  | NavListGroupSection
  | NavTileSection
  | NavAccordion
  | RawHtmlSectionFragmentFragment
  | NavRegionLocaleSection

// This is a fake section someone made and injected as a section for a NavTab
/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavRegionLocaleSection = {
  __typename: 'NavRegionLocaleSection'
  id: string
}

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavTabData =
  | GetSiteFixturesQuery['siteFixtures']['navigation']['desktopTabs'][number]
  | GetSiteFixturesQuery['siteFixtures']['navigation']['mobileTabs'][number]

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavTabSectionData = NavTabData['sections'][number] | NavRegionLocaleSection

/**
 * @deprecated Use local generated types, not globally defined ones with hardcoded values.
 */
export type NavTab = Omit<NavTabData, 'sections'> &
  ClientSideNavTabAdditions & {
    sections: Array<NavTabSectionData & ClientSideNavSectionAdditions>
  }
